import { render, staticRenderFns } from "./dataDownload.vue?vue&type=template&id=28020cee&scoped=true&"
import script from "./dataDownload.vue?vue&type=script&lang=js&"
export * from "./dataDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28020cee",
  null
  
)

export default component.exports